import React from 'react';
import './Menu.css';
import { MenuItem } from './MenuItem';
import { Category } from '../../data/RowData';
import { useAppContext } from '../../services/AppService';

export const Menu: React.FC = () => {
	const { state, setState } = useAppContext();

	return (
		<>
			<div className='menu'>
				<div className='hamburger' onClick={() => setState('hamburgerMenuIsOpen', !state.hamburgerMenuIsOpen)}>
					<div />
					<div />
					<div />
				</div>
				<nav className={state.hamburgerMenuIsOpen ? 'open' : ''}>
					{[Category.all, Category.doc, Category.app, Category.misc, Category.drive, Category.safeCert, Category.ver].map((n, i) => (
						<MenuItem
							name={n}
							key={i}
							index={i}
							onClick={() => {
								setState('category', n);
								setState('hamburgerMenuIsOpen', false);
							}}
						/>
					))}
				</nav>
			</div>
		</>
	);
};
